import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../lib/utils";

/**
 * Brand logo.
 *
 * Replacing the logo:
 *   1. Overwrite /app/frontend/public/logo.webp  (used on light backgrounds)
 *   2. Optionally overwrite /app/frontend/public/logo-dark.webp (light-ink version
 *      used on dark backgrounds). If it is missing, logo.webp is used for both.
 * No code changes are required.
 */
export const Logo = ({ className, size = "h-7", to = null }) => {
  const content = (
    <>
      <img
        src="/logo.webp"
        alt="Invextiing"
        className={cn(size, "w-auto object-contain dark:hidden")}
        draggable={false}
      />
      <img
        src="/logo-dark.webp"
        alt="Invextiing"
        className={cn(size, "hidden w-auto object-contain dark:block")}
        draggable={false}
        onError={(e) => {
          e.currentTarget.src = "/logo.webp";
        }}
      />
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className={cn("inline-flex shrink-0 items-center", className)}
        data-testid="brand-logo-link"
      >
        {content}
      </Link>
    );
  }
  return (
    <span className={cn("inline-flex shrink-0 items-center", className)} data-testid="brand-logo">
      {content}
    </span>
  );
};

export const BrandMark = ({ className }) => (
  <span className={cn("inline-flex items-center gap-2 font-semibold tracking-tight", className)}>
    <span className="relative inline-block h-5 w-5">
      <span className="absolute left-0 top-0 h-2.5 w-2.5 rotate-12 bg-primary" />
      <span className="absolute bottom-0 left-1 h-2.5 w-2.5 rounded-full bg-primary" />
    </span>
    <span>
      Invext<span className="text-primary">iing</span>
    </span>
  </span>
);
